const FooterData = [
      
    {
        title: "Services",
        submenu: [
            {

                title: "Professionals",
                link: "/professionals"
            },
            {
                title: "Organizations",
                link: "/organizations"
            }
            // ,
            // {
            //     title: "Blogs",
            //     link: "/blogs"
            // }
        ]
    },
    {
        title: "Quick Link",
        submenu: [
            {
                title: "Terms Of Use",
                link: "/term_policy"
            },
            {
                title: "Privacy",
                link: "/privacy"
            },
            {
                title: "Contact us",
                link: "/contact_us"
            },
        ]
    },
]

export default FooterData